
<iframe [style.height]="innerHeight" id="PluginProduzioneIframe" style="width: 100%;" [src]="certurl | safe" title="Plugin Production"></iframe>
